import React from 'react';
import PropTypes from 'prop-types';
import Breakpoint from './breakpoint';

const NotDesktopBreakpoint = props => (
  <Breakpoint name="notDesktop">
    {props.children}
  </Breakpoint>
);

NotDesktopBreakpoint.propTypes = {
  children: PropTypes.node.isRequired,
};

export default NotDesktopBreakpoint;



// WEBPACK FOOTER //
// ./src/app/components/responsiveUtilities/notDesktop.jsx